import { api } from "../../services/NetworkBase";

export async function LookupOrderForCoc(orderNumber) {
    try {
        let response = await api.get(`vlp/chain-of-custody/lookup/${encodeURIComponent(orderNumber)}`).json();
        return response;
    } catch (error) {
        throw error;
    }
}

export async function AttachCoc(file, orderNumber) {
    const form = new FormData();
    form.append("file", file, file.name || `${orderNumber}.jpg`);
    form.append("orderNumber", orderNumber);
    try {
        let response = await api.post("vlp/chain-of-custody/attach", { body: form, timeout: 120000 }).json();
        return response;
    } catch (error) {
        // Pull the server-provided message out of the response body so the UI can
        // show what actually failed instead of a generic "Attach failed (500)".
        let serverMessage = "";
        try {
            const body = await error?.response?.json?.();
            serverMessage = body?.results?.message || body?.message || "";
        } catch { /* body wasn't JSON */ }
        if (serverMessage) error.serverMessage = serverMessage;
        throw error;
    }
}
